export const openCloudBasePath = '/reference/cloud';
export const endpointsID = 'endpoints';
export const objectsID = 'objects';
export const resourcePathsSelectListID = 'resource-paths-select-list';
